// extracted by mini-css-extract-plugin
module.exports = {"container":"Course_container__smCRu","containerDisabled":"Course_containerDisabled__M3_CK"};